import React from "react";
import { plansData } from "../../data/plansData";
import whiteTick from "../../assets/whiteTick.png";
import "./plans.css";

const Plans = () => {
  return (
    <div className="plans-container">
      <div className="blur plans-blur-1"></div>
      <div className="blur plans-blur-2"></div>

      {/* Section Heading */}
      <div className="programs-header" style={{ gap: "2rem" }}>
        <span className="stroke-text">GET STARTED</span>
        <span>CHOOSE YOUR PLAN</span>
        <span className="stroke-text">TRAIN WITH US</span>
      </div>

      {/* Plans Card */}
      <div className="plans">
        {plansData.map((plan, i) => (
          <div className="plan" key={i}>
            {plan.icon}
            <span className="plan-name">{plan.name}</span>
            <span className="plan-price">$ {plan.price}</span>

            <div className="features">
              {plan.features.map((feature, j) => (
                <div key={j} className="feature">
                  <img src={whiteTick} alt="Feature included" />
                  <span>{feature}</span>
                </div>
              ))}
            </div>

            <div className="see-more">
              <span>More Benefits →</span>
            </div>

            <button className="btn">Join Now</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Plans;
